// @flow

export const getWordCount = (text: string): ?number => {
  const words = text.match(/\w+/g);

  return words && words.length;
};



// WEBPACK FOOTER //
// ../utilities/wordCount.js